export const selectWallets = store => store.walletsStore.wallets;
export const selectWalletsDetails = store => store.walletsStore.currentWallet;
export const selectIsLoading = store => store.walletsStore.isLoading;
export const selectWalletsError = store => store.walletsStore.isError;